module.exports = __webpack_public_path__ + "img/devnone.83c84073.png";